'use client'

import { useState } from 'react'

export function DirectoryBrandTile({
  name,
  logoUrl,
  href,
  compact = false,
}: {
  name: string
  logoUrl?: string | null
  href?: string
  compact?: boolean
}) {
  const [imageError, setImageError] = useState(false)
  const trimmedLogo = logoUrl?.trim()
  const hasValidLogo = Boolean(trimmedLogo && !imageError)

  const tileContent = (
    <div
      className={`bg-white ${
        compact ? 'p-2' : 'p-4'
      } rounded-lg flex items-center justify-center h-32 transition-all group`}
    >
      <div className="h-16 w-full flex items-center justify-center">
        {hasValidLogo && trimmedLogo ? (
          // eslint-disable-next-line @next/next/no-img-element
          <img
            src={trimmedLogo}
            alt={name}
            title={name}
            className="max-h-full max-w-full object-contain"
            onError={() => setImageError(true)}
          />
        ) : (
          <span
            className={`text-center font-bold tracking-tight text-charcoal-800 uppercase px-2 line-clamp-2 select-none ${
              compact ? 'text-xs' : 'text-sm'
            }`}
            title={name}
          >
            {name}
          </span>
        )}
      </div>
    </div>
  )

  if (href) {
    return (
      <a
        href={href}
        className="block w-full hover:-translate-y-0.5 transition-transform duration-200"
      >
        {tileContent}
      </a>
    )
  }

  return (
    <div className="w-full hover:-translate-y-0.5 transition-transform duration-200">
      {tileContent}
    </div>
  )
}


